import type { Location } from '@direct-frontend/modules-router';

const getPathname = (href?: string) => (href ? href.replace(/^(https?:)?\/\/[^\/]*/, '').split(/[?#]/)[0] || '/' : '');

export const isActiveStep = ({ pathname }: Location, step: { href?: string; subtasks: { href?: string }[] }) =>
    getPathname(step.href) === pathname || step.subtasks.some((subtask) => getPathname(subtask.href) === pathname);
